import { APIForm } from './_api-form.js';
class ContactForm extends APIForm {
  constructor() {
    super();
    this._successModalId = null;
  }
  connectedCallback() {
    super.connectedCallback();
    // Get the success modal ID from the data-success attribute
    this._successModalId = this.getAttribute('data-success');
  }
  disconnectedCallback() {
    super.disconnectedCallback();
  }
  _getDefaultEndpoint() {
    return "/wp-json/api/v1/contact";
  }
}
customElements.define('contact-form', ContactForm);